/* tslint:disable */
/* eslint-disable */
/**
 * GateHouse AIS REST interface
 * AIS system for monitoring vessel traffic. Commercial WebService. Contact GateHouse support for more information.
 *
 * The version of the OpenAPI document: 0.2.2
 * Contact: support@gatehouse.dk
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { ShipPositionItem } from './ShipPositionItem';
import {
    ShipPositionItemFromJSON,
    ShipPositionItemFromJSONTyped,
    ShipPositionItemToJSON,
} from './ShipPositionItem';

/**
 * Zero or more ships found inside the area.
 * @export
 * @interface ShipPositionResponse
 */
export interface ShipPositionResponse {
    /**
     * 
     * @type {Array<ShipPositionItem>}
     * @memberof ShipPositionResponse
     */
    records?: Array<ShipPositionItem>;
}

/**
 * Check if a given object implements the ShipPositionResponse interface.
 */
export function instanceOfShipPositionResponse(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function ShipPositionResponseFromJSON(json: any): ShipPositionResponse {
    return ShipPositionResponseFromJSONTyped(json, false);
}

export function ShipPositionResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): ShipPositionResponse {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'records': !exists(json, 'records') ? undefined : ((json['records'] as Array<any>).map(ShipPositionItemFromJSON)),
    };
}

export function ShipPositionResponseToJSON(value?: ShipPositionResponse | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'records': value.records === undefined ? undefined : ((value.records as Array<any>).map(ShipPositionItemToJSON)),
    };
}

